module.exports = __webpack_public_path__ + "public/hws/images/firefox.png";


//////////////////
// WEBPACK FOOTER
// ./public/hws/images/firefox.png
// module id = 323
// module chunks = 0